import { useCart } from "./components/CartContext";
import "./components/Product.css";
import "./Contact.css";

const CONTACT_ITEMS = [
  {
    id: "MM-CONTACT-VEG",
    name: "Vegetables",
    shortDescription:
      "Fresh daily vegetables sourced from trusted local farms.",
    price: 149,
    originalPrice: 199,
    image: "/image/groceries.png",
  },
  {
    id: "MM-CONTACT-BIKE",
    name: "Bike Delivery",
    shortDescription:
      "Fast two-wheeler delivery for urgent orders and short routes.",
    price: 99,
    originalPrice: 129,
    image: "/image/Transportation-Technology.png",
  },
  {
    id: "MM-CONTACT-CAR",
    name: "Car Delivery",
    shortDescription:
      "Comfortable and secure delivery for larger and bulk items.",
    price: 179,
    originalPrice: 229,
    image: "/image/Vehicle-EvaluationandSoftware-related-tech.png",
  },
];

export default function Contact() {
  const { cart, addToCart, increaseQuantity, decreaseQuantity, formatPrice } =
    useCart();

  return (
    <div className="product-page-container contact-items-page">
      <div className="product-page-header4 contact-items-header">
        <h2 className="product-page-title4 contact-items-title">
          <span className="white-text">Contact</span>
        </h2>
      </div>

      <div className="product-grid contact-items-grid">
        {CONTACT_ITEMS.map((item, index) => {
          const inCart =
            cart.find((cartItem) => cartItem.id === item.id)?.quantity || 0;
          const discountPercent = Math.round(
            ((item.originalPrice - item.price) / item.originalPrice) * 100
          );

          return (
            <div
              key={item.id}
              className="product-card animate-card"
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <img src={item.image} alt={item.name} className="product-image" />
              <h4 className="product-name">{item.name}</h4>
              <p className="product-description">{item.shortDescription}</p>

              <div className="price-section">
                <span className="discounted-price">
                  {formatPrice(item.price)}
                  <span className="discount"> ({discountPercent}% OFF)</span>
                </span>
                <span className="original-price">
                  {formatPrice(item.originalPrice)}
                </span>
              </div>

              <div className="product-action-area">
                {inCart > 0 ? (
                  <div className="quantity-control-container2">
                    <button
                      className="quantity-button-products decrease"
                      onClick={() => decreaseQuantity(item.id)}
                    >
                      -
                    </button>
                    <div className="quantity-display">{inCart}</div>
                    <button
                      className="quantity-button-products increase"
                      onClick={() => increaseQuantity(item.id)}
                    >
                      +
                    </button>
                  </div>
                ) : (
                  <button className="add-button" onClick={() => addToCart(item)}>
                    ADD
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export { Contact };
